import React from 'react';

export type MaiSectionProps = {
  label: string;
  count?: number | null;
  loading?: boolean;
  empty?: string | null;
  showEmpty?: boolean;
  children?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
  id?: string;
};

export const MaiSection: React.FC<MaiSectionProps> = ({
  label,
  count,
  loading,
  empty,
  showEmpty,
  children,
  actions,
  className,
  id,
}) => (
  <section id={id} className={`mai-section ${className || ''}`}>
    <div className="mai-section-head">
      <div className="mai-section-label">
        {label}
        {typeof count === 'number' && count > 0 ? ` (${count})` : ''}
      </div>
      {actions}
    </div>
    {loading && (
      <div className="mai-empty-state is-loading" aria-busy="true">
        <span className="mai-skeleton-bar" />
        <span className="mai-skeleton-bar is-short" />
        <span className="mai-visually-hidden">Carregando…</span>
      </div>
    )}
    {!loading && showEmpty && (
      <div className="mai-empty-state">
        <p className="mai-empty-state-body">{empty || 'Nada por aqui agora. Quando houver itens, eles aparecem nesta seção.'}</p>
      </div>
    )}
    {!loading && children}
  </section>
);

export default MaiSection;
